import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next'
import { Grid, Box, Drawer, ListItem, CircularProgress } from '@material-ui/core';
import Container from '../../components/Container'
import { Field, Form } from 'react-final-form';
import { TextFieldComponent, DatePickerComponent, TextFieldWithSelectComponent } from '../../components/FormElement';
import Button from '../../components/ButtonCustom';
import { portalCfg } from '../../../portal.router.config';
import CustomTypo from '../../components/CustomTypo';
import DrawerCustom from '../../components/DrawerCustom';
import {CheckIcon, ErrorIcon, SwichGreenActiveIcon, SwichIcon} from '../../components/icons'
import {Cancel, FormatListNumberedRtlOutlined} from '@material-ui/icons'
import Divider from '../../components/Divider'
import validators from '../../utils/validators';
import CustomizedCircularProgress, { CustomizedCircularProgressLight } from '../../components/CircularProgress';
import { getAppCfg, getCurrency } from '../../utils/common';
import { formatDateTimeFrEpoch } from '../../utils/util';
const referFriendLogo = portalCfg.publicPath + "/assets/images/refer_friend.svg";

    const styles = theme => ({
        form: {
            backgroundColor: theme.palette.background.secondary,
            padding: theme.spacing(3,4,3,4),
            borderRadius: theme.spacing(4),
            marginTop: theme.spacing(2),
        },
        button: {
            marginTop: theme.spacing(8)
        },
        marginTop:{
            marginTop: theme.spacing(4)
        },
        form2:{
            marginTop: theme.spacing(4)
        },
        bordered: {
            borderRadius: 8,
            borderWidth: 1,
            borderColor: theme.palette.border.primary,
            padding: 16
        },
        boxItemContent: {
            padding: theme.spacing(3,4,3,4),
            marginTop: theme.spacing(2),
            border: '1px solid',
            borderColor: theme.palette.border.transparent,
            backgroundColor: theme.palette.background.secondary,
            borderRadius: theme.spacing(4),
            boxShadow: '1px 2px 10px -6px rgba(0,0,0,0.75)',
            cursor: 'pointer',
        },
        // form:{
        //     padding: theme.spacing(4),
        // },
        // button:{
        //     padding: theme.spacing(2),
        // }
});

function SpendingPreferencesView(props) {
    const getMerchantName = (data) =>{
        let str = "";
        data.map(item => {
            str = str + item.name + ","
        })
        if(str){
            str = str.substr(0,str.length -1);
        }
        return str;
    }
    const checkMerchantSelected = (merchant) =>{
        let isSelected = false
        let merchantSelected = props.merchantSelected;
        if (merchantSelected.length > 0) {
            let itemExist = merchantSelected.filter(item => {
                return item.id == merchant.id
            })
            if (itemExist && itemExist.length > 0) {
                isSelected = true;
            }
        }
        return isSelected;
    }

    const { classes, t, onHandleChange, isValueNull, setting, any_purchase, merchantSelected, any_purchase_collect_on , contact_otp} = props
    //console.log('setting====',props.setting)
    let enableSaveButton = !props.setting.from_purchase_amount && !props.setting.minimum_wallet_balance;
    if(!props.setting.from_purchase_amount && !props.setting.minimum_wallet_balance)
        enableSaveButton = true;
    if(props.setting.from_purchase_amount && props.setting.minimum_wallet_balance)
        enableSaveButton = true;

    let minimumWalletBalance = null;   
    let fromPurchaseAmount = null; 

    if(props.setting.minimum_wallet_balance===0){
        minimumWalletBalance = '0'
    }
    else if(props.setting.minimum_wallet_balance){
        minimumWalletBalance = props.setting.minimum_wallet_balance.toString()
    }
    else{
        minimumWalletBalance = null
    }

    if(props.setting.from_purchase_amount===0){
        fromPurchaseAmount = '0'
    }
    else if(props.setting.from_purchase_amount){
        fromPurchaseAmount = props.setting.from_purchase_amount.toString()
    }
    else{
        fromPurchaseAmount = null
    }
    const appConfig = getAppCfg();
    let currency = getCurrency();
    let customer_selfservice_purchases = appConfig && appConfig.features && appConfig.features.rewards_details && appConfig.features.rewards_details.customer_selfservice_purchases
        //console.log(' minimumWalletBalance======',minimumWalletBalance)
    return (
        <div>
            <DrawerCustom
                open={props.open}
                enableBack
                onClose={props.onClose}
                title = {t('spending_preferences')}
                children={
                    <Grid item >
                        {/* {props.showLoading&&<CustomizedCircularProgress/>} */}
                        <Form
                            onSubmit={props.editable?props.onSave: props.onEdit}
                            render={({ handleSubmit, reset, submitting, pristine, values }) => (
                                <Grid xs={12} container item justify='center' className={classes.form}>
                                    <Grid item xs={10} container justify='flex-start'>
                                        <CustomTypo variant='subtitle2'>{t('automatic_spend')}</CustomTypo>
                                    </Grid>
                                    <Grid item xs={2} container justify='flex-end' onClick={!props.showLoading? () => props.onSwitchAutomaticSpend(!setting.enable_automatic_spend) : null} style={{cursor:'pointer'}}>
                                        {setting.enable_automatic_spend ? <SwichGreenActiveIcon/>:<SwichIcon/>}
                                    </Grid>
                                    <Divider/>
                                    <Grid item xs={12} container justify='flex-start'>
                                        {setting.enable_automatic_spend && any_purchase ? <CustomTypo mg_top_xs>{t('spend_setting_intro')}</CustomTypo> : null}
                                        {!setting.enable_automatic_spend && any_purchase ? <CustomTypo mg_top_xs>{t('automatic_spend_info')}</CustomTypo> : null}
                                        {setting.enable_automatic_spend && !any_purchase ? <CustomTypo mg_top_xs>{t('spend_setting_merchant_intro')}</CustomTypo> : null}
                                    </Grid>
                                    {props.showLoading&&<Grid xs={12} item container justify='center'><CustomizedCircularProgressLight/></Grid>}    
                                    {setting.enable_automatic_spend && any_purchase && <Grid item xs={12}container className={classes.form2}>
                                        <Grid xs={12} item container>
                                            <Field
                                                name="minimum_wallet_balance"
                                                component={TextFieldComponent}
                                                defaultValue = {minimumWalletBalance}
                                            label={t('start_spending')}
                                                placeholder={t('enter_amount')}
                                                isEdit={props.editable}
                                                color='default'
                                                isValueNull={isValueNull}
                                                onCustomChange={(event)=>onHandleChange('minimum_wallet_balance', event)}
                                                validate={validators.composeValidators(validators.mustBeNumberRequired)}
                                                //onChange={(text) => props.onHandleChange('minimum_wallet_balance', text)}
                                            />
                                        </Grid>

                                        <Grid xs={12} item container>
                                            <Field
                                                name="from_purchase_amount"
                                                component={TextFieldComponent}
                                                label={t('allowed_amount')}
                                                placeholder={t('enter_amount')}
                                                isEdit={props.editable}
                                                color='default'
                                                isValueNull={isValueNull}
                                                defaultValue={fromPurchaseAmount}
                                                onCustomChange={(event) =>onHandleChange('from_purchase_amount', event)}
                                                validate={validators.composeValidators(validators.mustBeNumberRequired)}
                                                //onChange={(text) => props.onHandleChange('from_purchase_amount', text)}
                                            />
                                        </Grid>
                                        {any_purchase_collect_on && any_purchase_collect_on == 'PREFERRED_MERCHANT' && <Grid item xs={12}>
                                            <CustomTypo color='label'>{t('and_purchase_at')}</CustomTypo>
                                            <Grid className={classes.bordered}>
                                                <CustomTypo>{merchantSelected.length > 0 ? getMerchantName(merchantSelected) : t('select_from_the_list')}</CustomTypo>
                                            </Grid>
                                        </Grid>}
                                        {props.editable&&<Grid xs={12} item container justify='center' className={classes.button}>
                                            <Button color='primary' fullWidth onClick={handleSubmit} disabled={!enableSaveButton} >{t('btn_save')}</Button>
                                        </Grid>}
                                        {!props.editable&&<Grid xs={12} item container justify='center' className={classes.button}>
                                            <Button color='primary' fullWidth onClick={props.onEdit} >{t('btn_edit')}</Button>
                                        </Grid>}                                       
                                    </Grid>}
                                    {setting.enable_automatic_spend && !any_purchase && <Grid item xs={12} container>
                                        <Grid item xs={12} container className={classes.bordered} onClick={props.onShowMerchangeList}>
                                            <CustomTypo>{merchantSelected.length > 0 ? getMerchantName(merchantSelected) : t('select_from_the_list')}</CustomTypo>
                                        </Grid>
                                        <Grid style={{ marginTop: 50 }}>
                                            <Button color='primary' fullWidth onClick={() => props.onSaveMerchantToSpend()}>{t('btn_save')}</Button>
                                        </Grid>
                                    </Grid>}
                                </Grid>
                            )} />
                        {!props.showRequestOTP&&customer_selfservice_purchases&&<Grid item xs={12} className={classes.boxItemContent} container onClick={props.onShowRequestOTP}>
                            <Grid item xs={10} container justify='flex-start'>
                                <CustomTypo variant='subtitle2'>{t('one_time_password_spend_request')}</CustomTypo>
                            </Grid>
                            {contact_otp?<Grid item xs={12} container>

                                <Grid item xs={12} container justify='center'>
                                    <CustomTypo variant='body1' color="label" mg_top_xl>{t('OTP')}</CustomTypo>
                                </Grid>    
                                <Grid item xs={12} container justify='center' style={{color: '#3498db'}}>
                                        <CustomTypo variant='caption1' >{contact_otp.value}</CustomTypo>
                                </Grid>
                                <Divider/>
                                <Grid item xs={12} container justify='center'>
                                    {contact_otp&&contact_otp.spend_amount ? <CustomTypo color="label" variant='input_label'>{t('request_otp_spend_amount')}{': '}{currency}{contact_otp.spend_amount.toFixed(2)}</CustomTypo> : <CustomTypo variant='input_label' color="label">{t('request_otp_no_spend_amount')}</CustomTypo>}
                                </Grid>
                                <Grid item xs={12} container justify='center'>
                                    {contact_otp&&contact_otp.expiration ? <CustomTypo variant='subtitle2'>{t('otp_expires')}: {formatDateTimeFrEpoch(contact_otp.expiration)}</CustomTypo> : null}
                                </Grid>
                            </Grid>:
                                <Grid item xs={12} container justify='center'>
                                    <CustomTypo mg_top_xl variant='body1' color="label">{t('one_time_password_spend_request_info')}</CustomTypo>
                                </Grid>}
                                {props.showLoadingOTP&&<Grid xs={12} item container justify='center'><CustomizedCircularProgressLight/></Grid>}   
                        </Grid>}
                        {props.showRequestOTP&&<Grid item xs={12} className={classes.boxItemContent} container>
                            <Grid item xs={10} container justify='flex-start'>
                                <CustomTypo variant='subtitle2'>{t('request_otp_spend_title')}</CustomTypo>
                            </Grid>
                                <Grid item xs={12} container justify='center'>
                                    <CustomTypo variant='body1' color="label">{t('request_otp_spend_amount')}</CustomTypo>
                                </Grid>    
                                <Grid item xs={12} container justify='center'>
                                    <CustomTypo variant='body2' color="error">{t('request_otp_spend_suggest')}</CustomTypo>
                                </Grid>    
                                <Form
                                    onSubmit={props.onRequestSpendOTP}
                                    render={({ handleSubmit, reset, submitting, pristine, values }) => (
                                    <Grid xs={12} item container className={classes.form}>
                                        <Field
                                            name="request_spend_amount"
                                            component={TextFieldComponent}
                                            isEdit={true}
                                            color='default'
                                            onCustomChange={(event)=>props.onHandleChange('request_spend_amount', event)}
                                            validate={validators.composeValidators(validators.mustBeNumberRequired)}
                                        />
                                    
                                        <Divider/>
                                        <Grid item xs={12} container style={{marginTop: 16}}>
                                            <Grid item xs={6} style={{paddingRigth: 8}}>
                                                <Button color='primary' fullWidth onClick={props.request_spend_amount?handleSubmit:props.onRequestSpendOTP}>{t('request_otp')}</Button>
                                            </Grid>
                                            <Grid item xs={6} style={{paddingLeft: 8}}>
                                                <Button fullWidth onClick={props.onShowRequestOTP}>{t('btn_cancel')}</Button>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                )}/>

                                

                        </Grid>}
                </Grid>}/>

        </div>
    );
}

export default withStyles(styles)(withTranslation()(SpendingPreferencesView));